import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNextAction } from '../../utils/gamificationActions';
import { Button } from '../common/Button';

interface NextStepBlockProps {
  completedTasks: string[];
  readinessPercentage: number;
  nextTask?: {
    id: string;
    title: string;
    description: string;
    xpReward: number;
  } | null;
}

export const NextStepBlock: React.FC<NextStepBlockProps> = ({
  completedTasks,
  readinessPercentage,
  nextTask,
}) => {
  const navigate = useNavigate();
  const action = useNextAction({ completedTasks, readinessPercentage });

  const description = nextTask
    ? `${nextTask.title} — earn ${nextTask.xpReward} XP`
    : action.message;

  const handleNavigate = () => {
    navigate(action.actionUrl);
  };

  return (
    <div className="hidden md:flex items-center">
      <div className="flex items-start gap-3 rounded-xl border border-neutral-200 bg-white px-4 py-3 shadow-sm max-w-sm">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-xl">
          {action.emoji}
        </div>
        <div className="flex-1">
          <p className="text-[11px] font-semibold uppercase tracking-wide text-primary">Next step</p>
          <p className="text-sm font-medium text-neutral-900 leading-snug">{description}</p>
          <Button
            size="sm"
            className="mt-2"
            onClick={handleNavigate}
          >
            {action.actionText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NextStepBlock;
